<template>
  <div>
    <div v-if="maxUserCount > 1" class="same-time-wrap">
      <p class="same-time-tit">자동결제/부가세 포함</p>
      <div class="same-time-ch">
        <button @click="setUserCount('minus')" :class="userCount <= 1 ? 'btn-minus-off' : 'btn-minus'"
                :disabled="userCount <= 1">인원감소</button>
        <span class="number-people-text01">{{ userCount }}회선</span>
        <button @click="setUserCount('plus')" :class="userCount >= maxUserCount ? 'btn-plus-off' : 'btn-plus'"
                :disabled="userCount >= maxUserCount">인원추가</button>
        <br><span class="same-time-name">동시 이용자수</span>
      </div>
    </div>
    <ul class="ticket-pooq-list">
      <li v-for="(data, index) in products" :key="index">
        <div class="ticket-left">
          <p v-if="maxUserCount <= 1" class="same-time-tit">자동결제/부가세 포함</p>
          <p class="ticket-name">{{ data.screen_name }} {{ data.quality_name }}</p>
          <span class="ticket-price" :style="'color: ' + productColor">
            <span v-if="data.concurrency[userCount-1].displayamount" class="ticket-discount">
              {{ setNumberCommas(data.concurrency[userCount-1].displayamount) }}원
            </span>
            {{ setNumberCommas(data.concurrency[userCount-1].amount) }}원
          </span>
          <span v-if="voucherType === 'partner_academy'" class="ticket-dc-academy" :style="academyStyle">아카데미 추가할인</span>
        </div>
        <div class="ticket-right">
          <a class="ticket-btn" @click.prevent="clickPurchase(data.concurrency[userCount-1])"
             :style="'background-color: ' + productColor" href="#">구매하기</a>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import utils from '@/common/util/utils'
import { URL_ORIGIN } from '@/common/constant'
export default {
  props: {
    products: {
      type: Array
    },
    productColor: {
      type: String
    },
    maxUserCount: {
      type: Number,
      default: 1
    },
    voucherType: {
      type: String
    },
    contentId: {
      type: String
    }
  },
  data () {
    return {
      userCount: 1,
      device: utils.cookies.getDevice()
    }
  },
  computed: {
    academyStyle () {
      return 'color:' + this.productColor + '; border:0.5px solid ' + this.productColor
    }
  },
  methods: {
    // 동시이용자수 체크
    setUserCount (type) {
      if (type === 'plus' && this.userCount < this.maxUserCount) {
        this.userCount++
      } else if (type === 'minus' && this.userCount > 1) {
        this.userCount--
      }
    },
    // 구매하기 버튼
    clickPurchase (product) {
//      let url = window.location.origin + '/callback.html?action=ClosePopupAndReload'
      let url = URL_ORIGIN + '/callback.html?action=ClosePopupAndReload'
      utils.common.showBillingPopup({ productId: product.productid, productType: 'all', returnUrl: url, contentType: 'movie', contentId: this.contentId })
    },
    setNumberCommas (data) {
      return utils.common.setNumberCommas(data)
    }
  }
}
</script>
<style scoped>
  .same-time-wrap {
    padding: 14px;
    width: 100%;
  }
  .same-time-tit {
    float: left;
    vertical-align: top;
    font-size: 12px;
    color: #777;
    padding: 0 0 5px;
  }
  .same-time-ch {
     float: right;
     vertical-align: middle;
     text-align: right;
  }
  .same-time-ch button {
    text-indent: -9999px;
    width: 32px;
    height: 32px;
  }
  .same-time-ch .btn-minus{
    background: url(/img/common/user-minus-active.png) no-repeat;
    background-size: 32px;
  }

  .same-time-ch .btn-minus-off{
    background: url(/img/common/user-minus.png) no-repeat;
    background-size: 32px;
  }

  .same-time-ch .btn-plus{
    background: url(/img/common/user-add-active.png) no-repeat;
    background-size: 32px;
  }

  .same-time-ch .btn-plus-off{
    background: url(/img/common/user-add.png) no-repeat;
    background-size: 32px;
  }
  .same-time-name {
    display: block;
    vertical-align: middle;
    text-align: center;
    font-size: 11px;
    color: #777;
    margin-top: 10px;
  }
  .ticket-pooq-list {
    padding: 0 15px;
  }
  .ticket-pooq-list .ticket-left {
    margin-top: 0;
    width: calc(100% - 80px);
  }
  .ticket-name {
    display: block;
    clear: both;
    margin: 0 0 6px;
    font-weight: 700;
    font-size: 15px;
    letter-spacing: -.2px;
    color: #23212a;
  }
  .ticket-price {
    font-weight: 700;
    font-size: 14px;
    vertical-align: middle;
  }
  .ticket-discount {
    opacity: .5;
    display: inline-block;
    margin-right: 5px;
    text-decoration: line-through;
  }
  .ticket-pooq-list .ticket-right {
    width: 80px;
    right: -15px;
    top: 50%;
    bottom: auto;
  }
  .ticket-dc-academy{
    display: block;
    width: 94px;
    padding: 3px 0;
    margin-top: 5px;
    font-size: 11px;
    line-height: 12px;
    text-align: center;
    border-radius: 5px;
  }
  .ticket-right {
    position: absolute;
  }

  .ticket-btn{
    display: inline-block;
    width: 72px;
    height: 30px;
    line-height: 30px;
    border-radius: 100px;
    font-size: 11px;
    text-align: center;
    color: #fff;
    vertical-align: middle;
  }
  .ticket-pooq-list li {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    padding: 17px 0;
  }
</style>
